// stores/profile.store.ts
import { signalStore, withState, withComputed, withMethods, patchState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { MenuLinkRapidiInterface } from '../models/interfaces/menu-link-rapidi.interface';

const menuLinkRapidi = {} as unknown as MenuLinkRapidiInterface;

export const MenuLinkRapidiStore = signalStore(
  { providedIn: 'root' }, 

  withState({
    menuLinkRapidi: menuLinkRapidi, 
    loaded: false,
    error: null as string | null
  }),
  withComputed(({ menuLinkRapidi }) => ({
    linkRapidi: computed(() => menuLinkRapidi().linkRapidi),
    vociMenu: computed(() => menuLinkRapidi().vociMenu),
    ruolo: computed(() => menuLinkRapidi().ruolo),
  })),
  withMethods((store) => {
    return {
      saveMenuLinkRapidiCompleta(menuLinkRapidiCompleta: MenuLinkRapidiInterface) {
        patchState(store, {
          menuLinkRapidi: menuLinkRapidiCompleta,
          loaded: true,
          error: null as string | null
        });
      },
    };
  }),
);
